import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { ArticleHeading4 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';
import { IPromo } from '../../types/newbuilding/promos';
import { PromoItemIcon } from '../PromoItemIcon';

interface IPromoItemProps {
  promo: IPromo;
  subtitle: React.ReactNode;
  onClick(): void;
}

export function PromoItem({ promo, subtitle, onClick }: IPromoItemProps) {
  const { name, isBlackFriday } = promo;

  return (
    <div className={styles['container']} onClick={onClick} data-testid="PromoItem">
      <div className={styles['icon-wrapper']}>
        <PromoItemIcon promo={promo} />
      </div>
      <div>
        <div className={styles['title']}>
          <ArticleHeading4 as="h4">{name}</ArticleHeading4>
        </div>
        <div className={styles['subtitle']}>
          {isBlackFriday && (
            <Label background="accent-main-primary" color="decorative-theme-white">
              Sale
            </Label>
          )}
          {subtitle}
        </div>
      </div>
    </div>
  );
}
